import { useTranslation } from 'react-i18next';
import config from '../../../../../config';
import { checkUser } from '../../../../../utils/checkUser';
import Form, { Input, SubmitButton, TextArea } from '../../../../molecules/Form';
import useChageProfile from './hook/useChageProfile';
import { handleBlur, handleFocus } from 'utils/contants';
import { useRef, useState } from 'react';
import ProfileImageUpload from './Components/ProfileImageUpload';
import axios from 'axios';
import { useEffect } from 'react';
import { apiCall } from 'crud/api.crud';

const getAdress = (addresses) => {
  if (!addresses || !addresses.length) return { address: '', address_info: '' };

  const lastAdress = addresses[addresses.length - 1];

  return { address_id: lastAdress.id, address: lastAdress.name, address_info: lastAdress.info };
};
const noEditableOptionalFields = ['optional_field_one', 'optional_field_two'];
const optionalFieldValidations = {
  optional_field_five: [{ key: 'required', val: true }],
};

const columnClasses = 'form-group  col-md-6';

const BaNortePersonalData = ({ user }) => {
  const stateIdRef = useRef();
  const [statesMexico, setStatesMexico] = useState([]);
  const { t } = useTranslation();
  const [currentImage, setCurrentImage] = useState(null);
  const {
    name,
    surname,
    email,
    id,
    volunteeringFields = {},
    addresses = [],
    talent = {},
    volunteeringOptionalFields = [],
  } = user;
  const defaultValue = {
    name,
    surname,
    email,
    id,
    image: talent.image || '',
    title: talent.title || '',
    short_description: talent.short_description || '',
    ...volunteeringFields,
    ...volunteeringOptionalFields,
    ...getAdress(addresses),
  };
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const result = await apiCall('entity/states/México', null, 'GET');
        setStatesMexico(result?.data.data || []);
      } catch (error) {
        console.error('Error al cargar estados:', error);
        setStatesMexico([]);
      }
    };

    fetchStates();
  }, []);

  const { change, isLoading, error, update, birthdateError, setBirthdateError } = useChageProfile(false);

  const handleImageChange = (file) => {
    setCurrentImage(file);
  };

  const handleSubmit = async (values) => {
    values.state_id = stateIdRef.current?.value || '';
    const today = new Date();
    const birthdate = new Date(values.birthday);

    if (birthdate > today) {
      setBirthdateError(true);
      return;
    }

    try {
      const formData = new FormData();
      formData.append('id', user.id);

      if (currentImage) {
        formData.append('image', currentImage);
      } else if (values.image) {
        formData.append('image', values.image);
      }

      formData.append('title', values.title || '');
      formData.append('short_description', values.short_description || '');

      await update({
        endpoint: 'profile/talents',
        data: formData,
        isFormData: true,
      });

      const volunteeringOptionalFields = {};
      Object.entries(values).forEach(([key, val]) => {
        if (key.startsWith('optional_field_')) {
          volunteeringOptionalFields[key] = val;
        }
      });

      const { image, title, short_description, ...rest } = values;

      await update({
        endpoint: 'profile',
        data: {
          ...rest,
          volunteering_optional_fields: volunteeringOptionalFields,
        },
      });
    } catch (err) {
      console.error('Error en la actualización del perfil:', err);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow bg-white rounded">
        <div
          className="card-header bg-white fw-bold"
          style={{
            borderBottom: '2px solid var(--primary)',
            fontWeight: 600,
          }}
        >
          {t('profile.profile_msg')}
        </div>
        <div className="card-body">
          <Form submit={handleSubmit} defaultValue={defaultValue}>
            <div className="row mb-4">
              <div className="col-md-4 d-flex justify-content-center align-items-start">
                <ProfileImageUpload
                  currentImage={currentImage}
                  onImageChange={handleImageChange}
                  userImage={talent.image}
                  name={name}
                />
              </div>
              {/* NOmbre */}
              <div className="col-md-8">
                <div className="row">
                  <div className="form-group col-md-6 mb-3">
                    <Input
                      label={t('profile.name')}
                      name="name"
                      type="text"
                      validations={[
                        { key: 'required', val: true },
                        { key: 'max_length', val: 50 },
                      ]}
                      readOnly
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                    />
                  </div>
                  {/* apellido */}
                  <div className="form-group col-md-6 mb-3">
                    <Input
                      label={t('profile.surname')}
                      name="surname"
                      type="text"
                      validations={[
                        { key: 'required', val: true },
                        { key: 'max_length', val: 50 },
                      ]}
                      readOnly
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                    />
                  </div>
                  {/* email */}
                  <div className="form-group col-md-6 mb-3">
                    <Input
                      label={t('profile.email_banorte')}
                      name="email"
                      type="email"
                      validations={[
                        { key: 'required', val: true },
                        { key: 'email', val: true },
                      ]}
                    />
                  </div>
                  {/* fecha de ncimiento */}
                  <div className="form-group col-md-6 mb-3">
                    <Input label={t('profile.profile_msg8')} name="birthday" type="date" validations={[]} />
                  </div>

                  {/* Teléfono */}
                  <div className={columnClasses}>
                    <Input
                      label={t('profile.profile_msg18')}
                      name="phone_number"
                      type="number"
                      validations={[ { key: 'required', val: true },{ key: 'max_length', val: 25 }]}
                    />
                  </div>
                  {/* Teléfono adicional */}
                  <div className={columnClasses}>
                    <Input
                      label={t('profile.profile_msg19')}
                      name="mobile_number"
                      type="number"
                      validations={[{ key: 'max_length', val: 25 }]}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* género */}
            <div className="row">
              <div className="form-group col-md-4 mb-3">
                <label>Sexo:</label>
                <input
                  className="form-control"
                  readOnly
                  name="gender"
                  value={
                    volunteeringFields.gender === 'Masculino'
                      ? 'Hombre'
                      : volunteeringFields.gender === 'Femenino'
                      ? 'Mujer'
                      : volunteeringFields.gender || 'null'
                  }
                />
              </div>
              {/* campos opcionales */}
              {config.userVolunteeringFields &&
                Object.entries(config.optionalFields)
                  .filter(([_, label]) => label && label.trim() !== '')
                  .map(([key, label]) => {
                    const value = user.volunteeringOptionalFields?.[key] || '';
                    const noEditable = noEditableOptionalFields.includes(key);

                    return (
                      <div className="form-group col-md-4 mb-3" key={key}>
                        <Input
                          label={label}
                          name={key}
                          validations={optionalFieldValidations[key] || []}
                          readOnly={noEditable}
                        />
                      </div>
                    );
                  })}
              {/* Estado de México */}
              <div className="row">
                {statesMexico.length > 0 && (
                  <div className="form-group col-md-4 mb-3">
                    <label htmlFor="state_id">Estado</label>
                    <select
                      className="form-control w-auto"
                      name="state_id"
                      defaultValue={(volunteeringFields.state_id || '').toString()}
                      ref={stateIdRef}
                    >
                      <option value="">Selecciona un estado</option>
                      {statesMexico.map((state) => (
                        <option key={state.id} value={state.id.toString()}>
                          {state.title}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            {config.catalogTalents && (
              <>
                <div className="form-group col-md-12 mb-3">
                  <Input
                    label="Rol"
                    name="title"
                    type="text"
                    validations={[
                      { key: 'required', val: true },
                      { key: 'max_length', val: 100 },
                    ]}
                  />
                </div>
                <div className="form-group col-md-12 mb-3">
                  <TextArea
                    label="Descripción"
                    name="short_description"
                    type="text"
                    validations={[
                      { key: 'required', val: false },
                      { key: 'max_length', val: 420 },
                    ]}
                  />
                </div>
              </>
            )}

            <SubmitButton isloading={isLoading} />
          </Form>
        </div>
      </div>

      {/* Mensajes de feedback */}
      {error && (
        <div className="alert alert-danger mt-3" role="alert">
          {t('profile.extra_msg1')}
        </div>
      )}
      {birthdateError && (
        <div className="alert alert-danger mt-3" role="alert">
          {t('profile.birthdate_error')}
        </div>
      )}
      {change && (
        <div className="alert alert-success mt-3" role="alert">
          {t('profile.extra_msg2')}
        </div>
      )}
      {!change && !checkUser(user).length && (
        <div className="alert alert-warning mt-3" role="alert">
          {t('profile.extra_msg3')}
        </div>
      )}
    </div>
  );
};
export default BaNortePersonalData;
